'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var BOOKING_VIRAL_HUBS_CTA = exports.BOOKING_VIRAL_HUBS_CTA = 'booking-page-signup-visual';
var THANKYOU_VIRAL_HUBS_CTA = exports.THANKYOU_VIRAL_HUBS_CTA = 'thank-you-page-signup-visual';

var wrongHubSpotDomain = exports.wrongHubSpotDomain = 'www.hubspot.com';

var wrongHubSpotQADomain = exports.wrongHubSpotQADomain = 'www.hubspotqa.com';

var hubSpotDomain = exports.hubSpotDomain = 'app.hubspot.com';

var hubSpotQADomain = exports.hubSpotQADomain = 'app.hubspotqa.com';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/constants/paths.js
// module id = 122
// module chunks = 0